import { isAfter, startOfDay, subWeeks } from 'date-fns';

const isRecentStarter = (startDate: string) => {
  const threshold = startOfDay(subWeeks(new Date(), 7));
  return isAfter(new Date(startDate), threshold);
};

export default isRecentStarter;
